export default __webpack_public_path__ + "static/media/gallery36_1.2cc40016.png";